export {
  Autoplay,
  EffectFade,
  Pagination,
  Swiper,
  SwiperSlide,
} from './swiper';
